import { AnalyzeConstants } from '../../../src/_constants/Analyze/analyze.constants';

const initialState = { headPerLoading: true, data: '', error: false };

export function headerPermissionReducer(state = initialState, action) {

    switch (action.type) {
        case AnalyzeConstants.REQUEST_HEADER_PERMISSSION:
            return {
                headPerLoading: true,
                data: '',
                error: false
            };
        case AnalyzeConstants.RECEIVE_HEADER_PERMISSSION:
            return {
                headPerLoading: false,
                data: action.res,
                error: false
            };
        case AnalyzeConstants.ERROR_HEADER_PERMISSSION:
            return {
                headPerLoading: false,
                data: '',
                error: true
            };
        default:
            return state
    }
}


// WEBPACK FOOTER //
// ./src/_reducers/Analyze/headerPermissionReducer.reducer.js